import Answer from "./Answer.js";

export default class Question {
  constructor(data) {
    this.id = data.id || "";
    this.title = data.title || "";
    this.description = data.description || "";
    this.dateOfCreate = data.date_of_create || "";

    this.creatorID = data.creator_id || "";
    this.creatorName = data.creator_name || "";
    this.creatorSpecifics = data.creator_specifics || "";
    this.creatorImageURL = data.creator_imageurl || "";

    this.likesCount = data.likes_count || 0;
    this.commentCount = data.comment_count || 0;

    this.answers = data.answers ? Answer.fromArray(data.answers) : [];
  }

  static fromArray(array) {
    return array.map((item) => new Question(item));
  }
}